import {Component, OnDestroy, OnInit} from '@angular/core';
import {RouteDataService} from "../../services/route-data/route-data.service";
import {NavigationEnd, Router} from "@angular/router";
import {Subject} from "rxjs";
import {Store} from "@ngrx/store";
import {filter, takeUntil} from "rxjs/operators";
import * as fromStore from "../../../store";

interface Page {
  title: string;
  path: string;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-breadcrumbs',
    templateUrl: './ds-breadcrumbs.component.html',
    styleUrls: ['./ds-breadcrumbs.component.scss'],
    standalone: false
})
export class DsBreadcrumbsComponent implements OnInit, OnDestroy {

  public pages: Page[];
  public showToggle: boolean = false;

  private hiddenPaths: string[] = ['website', 'booster', 'hosting', 'builder', 'themes', 'installed-plugins',
    'change-environment', 'change-environment-dev', 'change-environment-live'];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _routeDataService: RouteDataService,
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
  ) {

  }

  ngOnInit() {
    this.getPages();
    this._router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        takeUntil(this._destroyStream$)
      )
      .subscribe(() => {
        this.getPages();
      });

  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  private getPages(): void {
    const data = this._routeDataService.getRouteDatas();
    const knowledgeBasePages = ["websites", "overview", "hosting-info", "hosting-domains", "hosting-tools", "redirects",
      "hosting-resource-usage", "logs",  "recreate-website", "templates", "plugins", "installed-add-ons", "backup",
      "security", "seo-overview", "image-optimizer", "move-to-10web", "pageSpeed"];
    this.showToggle = false;
    this.pages = data.reduce((result: Page[], route): Page[] => {
      if (route.pageId === 'hosting-domains-manage-dns') {
        const website = data[0].data && data[0].data.website;
        return [...result,
          {
            title: website ? 'Hosting: Domains' : 'Manage DNS',
            path: website ? `websites/${website.id}/domains` : 'domains-manage-all'
          },
          {
            title: `DNS: ${route.data.hostingZoneData.zone.name}`,
            path: ''
          }];
      }
      if (!this.hiddenPaths.includes(route.pageId)) {
        this.showToggle = knowledgeBasePages.includes(route.pageId);
        return [...result, {title: route.title, path: route.url}];
      }
      return result;
    }, []);
  }

  public toggleKnowLedgeBase(): void {
    this._store.dispatch(new fromStore.ToggleKnowledgeBase());
  }

}
